import { environment } from './../../../../environments/environment';
import { HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WorkflowModelsNS } from '../models/add-update-workflow.models';
import { NotificaitonEmailTemplateModel } from '../models/notification-email-template.model';

@Injectable()
export class WorkflowService {

    workflowAPI: string;
    taskSchedulerAPI: string;
    coreUrl: string;
    notificationApi: string;

    constructor(private http: HttpClient) {
        this.workflowAPI = environment.workflowAPI;
        this.taskSchedulerAPI = environment.taskSchedulerAPI;
        this.coreUrl = environment.coreUrl;
        this.notificationApi = environment.notificationUrl2;
    }

    addNewWorkflow(workflowData: WorkflowModelsNS.WorkflowAddEditDetails): Observable<any> {
        return this.http.post<any>(`${this.workflowAPI}WorkFlow?workflowModuleId=${303}`, workflowData);
    }

    updateWorkflow(workflowData: WorkflowModelsNS.WorkflowAddEditDetails): Observable<any> {
        return this.http.put<any>(`${this.workflowAPI}WorkFlow/${workflowData.id}?workflowModuleId=${303}`, workflowData);
    }

    //Delete workflow
    deleteWorkflow(workflowId: number) {
        return this.http.delete<any>(`${this.workflowAPI}Workflow/${workflowId}`);
    }

    //Workflow by Id
    getWorkflowById(id: number): Observable<WorkflowModelsNS.WorkflowDetails> {
        return this.http.get<any>(`${this.workflowAPI}Workflow/${id}?status=1`);
    }

    //Workflow by Id
    getWorkflowByName(name: string): Observable<WorkflowModelsNS.WorkflowDetails> {
        let params = new HttpParams()
        .set('name', name)
        .set('status', 1)

        return this.http.get<any>(`${this.workflowAPI}Workflow/Name`, { params });
    }

    //Get Workflow List
    getAlWorkflowList(pageNumber: number, pageSize: number, isActive: boolean, options?): Observable<any> {
        let url = `${this.workflowAPI}Workflow/PagedList?PageNumber=${pageNumber}&PageSize=${pageSize}&status=${isActive?1:2}`;

        if (options) {
            if (options.sort) {
                url = `${url}&SortBy=${options.sort.SortBy}&IsAscending=${options.sort.IsAscending}`;
            }
            if (options.filter && options.filter.field) {
                url = `${url}&SearchValue=${options.filter.value}&SearchColumns=${options.filter.field}`;
            }
            if (options.moduleSearchValue) {
                url = `${url}&ModuleSearchValue=${encodeURIComponent(options.moduleSearchValue)}`;
            }
        }

        // default sorting
        if (!options || !options.sort) {
            url = `${url}&SortBy=lastUpdated&IsAscending=false`;
        }

        return this.http.get<any>(url, {
            observe: 'response',
            headers: new HttpHeaders()
        });
    }

    //Get Mass Edit List
    getAllMassEditList(objectId: number, channelId: number, pageNumber: number, pageSize: number, options?): Observable<any> {
        let url = `${this.workflowAPI}Workflow/MassEdit/PagedList?PageNumber=${pageNumber}&PageSize=${pageSize}&objectId=${objectId}&channelId=${channelId}`;

        if (options) {
            if (options.sort) {
                url = `${url}&SortBy=${options.sort.SortBy}&IsAscending=${options.sort.IsAscending}`;
            }
            if (options.filter && options.filter.field) {
                url = `${url}&SearchValue=${options.filter.value}&SearchColumns=${options.filter.field}`;
            }
            if (options.moduleSearchValue) {
                url = `${url}&ModuleSearchValue=${encodeURIComponent(options.moduleSearchValue)}`;
            }
        }

        // default sorting
        if (!options || !options.sort) {
            url = `${url}&SortBy=lastUpdated&IsAscending=false`;
        }

        return this.http.get<any>(url, {
            observe: 'response',
            headers: new HttpHeaders()
        });
    }

    //Get Workflow List
    getWorkflowExecutionHistory(workflowId: number,pageNumber: number, pageSize: number,options?): Observable<any> {
        let url = `${this.workflowAPI}Workflow/ExecutionHistory/${workflowId}?PageNumber=${pageNumber}&PageSize=${pageSize}`;

        if (options) {
            if (options.sort) {
                url = `${url}&SortBy=${options.sort.SortBy}&IsAscending=${options.sort.IsAscending}`;
            }
            if (options.filter && options.filter.field) {
                url = `${url}&SearchValue=${options.filter.value}&SearchColumns=${options.filter.field}`;
            }
            if (options.moduleSearchValue) {
                url = `${url}&ModuleSearchValue=${encodeURIComponent(options.moduleSearchValue)}`;
            }

            if(options?.workflowConditionId){
                url = `${url}&WorkflowConditionId=${options.workflowConditionId}`;
            }

            if(options?.workflowActionId){
                url = `${url}&WorkflowActionId=${options.workflowActionId}`;
            }


            url = `${url}&WorkflowActionType=${options.workflowActionType||0}`;
            url =  `${url}&executionStatus=${options.executionStatus||0}`;

        }

        // default sorting
        if (!options || !options.sort) {
            url = `${url}&SortBy=CreatedDate&IsAscending=false`;
        }

        return this.http.get<any>(url, {
            observe: 'response',
            headers: new HttpHeaders()
        });
    }

    runWorkflowScheduler(workflowId): Observable<any> {
        // return this.http.get<any>(`${this.taskSchedulerAPI}WorkFlowScheduler?workflowId=${workflowId}`);

        return this.http.get(`${this.taskSchedulerAPI}WorkFlowScheduler?workflowId=${workflowId}`, {
            observe: 'response',
            responseType: 'text',
            headers: new HttpHeaders()
        });
    }

    removeWorkflowScheduler(jobId: string): Observable<any> {
        return this.http.delete(`${this.taskSchedulerAPI}WorkFlowScheduler/RemoveJob/${jobId}`,{
            observe: 'response',
            responseType: 'text',
            headers: new HttpHeaders()
        });
    }

    runNowWorkflowScheduler(workflowId): Observable<any> {
        return this.http.get(`${this.taskSchedulerAPI}WorkFlowScheduler/RunNow/${workflowId}`, {
            observe: 'response',
            responseType: 'text',
            headers: new HttpHeaders()
        });
    }

    //Get Email Templates
    getEmailTemplates(moduleId: number, channelId: number, statusId: number = 1): Observable<NotificaitonEmailTemplateModel[]> {
        let params = new HttpParams()
        .set('moduleId', moduleId)
        .set('channelId', channelId)
        .set('status', statusId)

        return this.http.get<any>(`${this.notificationApi}NotificationTemplate`, { params });
    }

}
